"use strict";

exports.__esModule = true;
exports["default"] = SocialGoogleInverted;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialGoogleInverted(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M280.2 284.3c-9.9-6.6-28.3-23.1-28.3-33.1 0-11.3 3.3-17 20.3-30.7 17.9-13.7 30.2-33.1 30.2-55.7-.1-26.9-11.9-52.8-34.6-61.3h34L325.9 86H219.2c-48.2 0-93 36.3-93 78.4 0 43 32.6 77.4 81.2 77.4 3.3 0 6.6 0 9.9-.5-3.3 6.1-5.2 13.2-5.2 20.3 0 11.8 6.1 21.3 14.2 29.3h-18.4c-59 0-104.8 37.8-104.8 77 0 38.7 50.1 62.8 109.1 62.8 68 0 105.3-38.2 105.3-77 0-30.7-9.4-49.1-37.3-69.4zM222.9 231c-27.4-.9-53.8-30.7-58.6-67-4.7-35.9 13.7-63.8 41.1-62.8 27.9.9 53.9 29.7 58.6 66 4.7 35.9-13.7 64.7-41.1 63.8zM212 413.7c-41.1 0-70.4-26-70.4-57.1 0-30.7 36.4-55.7 77.5-55.7 9.5.5 18.5 1.9 26.4 4.2 22.2 15.6 38.3 24.5 43 42 .4 3.8.9 7.1.9 10.9 0 31.1-19.8 55.7-77.4 55.7zm222.5-183.2h-38.2v-38.2h-25.5v38.2h-38.2V256h38.2v38.2h25.5V256h38.2v-25.5z",
    fill: "#939496"
  }));
}